import {
  createRootRouteWithContext,
  Outlet,
  useRouterState,
} from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { Header } from "@/components/layout/Header";
import { ApprovalBanner } from "@/components/layout/ApprovalBanner";
import { Footer } from "@/components/layout/Footer";
import { Toaster } from "@/components/ui/toaster";
import { PlatformLockGate } from "@/components/platform-lock/PlatformLockGate";
import { isPlatformLockProtectedPath } from "@/lib/platform-lock-shared";
import { renderedPathname } from "@/lib/rendered-pathname";

interface RouterContext {
  queryClient: QueryClient;
}

const AUTH_ROUTES = ["/login", "/register"];

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  // Not s.location: it jumps to the target before the old page is replaced.
  const pathname = useRouterState({ select: renderedPathname });

  const isDashboard = pathname.startsWith("/dashboard");
  const isAuthPage = AUTH_ROUTES.includes(pathname);
  const isPublicTest = pathname.startsWith("/test/");

  const content = isAuthPage || isDashboard || isPublicTest ? (
    <>
      <Outlet />
      <Toaster />
    </>
  ) : (
    <>
      <Header />
      <ApprovalBanner />
      <main>
        <Outlet />
      </main>
      <Footer />
      <Toaster />
    </>
  );

  if (isPlatformLockProtectedPath(pathname)) {
    return <PlatformLockGate>{content}</PlatformLockGate>;
  }

  return content;
}
